import { InjectionToken } from "@angular/core";

export const TipoModelToken = new InjectionToken("TipoModelToken");
